import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../../components/Modal"
import Button from "../../../../components/Button";
import { renderSettingsResourceLabel } from "../../../../utils/helpers/settings";

const messageKeyByColumn = {
    in: "mandatory-break-warning-in",
    out: "mandatory-break-warning-out",
    duration: "mandatory-break-warning-duration",
    "pay-code-with-duration": "mandatory-break-warning-pay-code-with-duration",
    "pay-code": "mandatory-break-warning-pay-code",
};

function MandatoryBreakWarning({ isOpen, close, selected }) {
    const { t } = useTranslation();

    const message = t(
        messageKeyByColumn[selected?.column] || "mandatory-break-warning-duration",
        {
            requiredTime: selected?.requiredTime,
            oldPayCode: renderSettingsResourceLabel(selected?.original?.payCode),
            newPayCode: renderSettingsResourceLabel(selected?.updatedFields?.payCode),
        },
    );

    const onCancel = useCallback(() => {
        selected?.onCancel?.();
        close();
    }, [selected, close]);

    const submit = useCallback(() => {
        selected?.onConfirm?.();
        close();
    }, [close, selected]);

    return (
        <Modal isOpen={isOpen} centered close={onCancel}>
            <div className="d-flex align-items-start gap-x-5 p-4">
                <FontAwesomeIcon
                    icon={faWarning}
                    className="text-warning mt-2"
                    style={{ fontSize: 30 }}
                />
                <div>
                    <p className="mb-3 font-weight-bold text-dark">{message}</p>
                    <p className="mb-0 font-weight-normal">{t("mandatory-break-warning-confirm")}</p>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
                <Button onClick={onCancel}>
                    {t("go-back-and-edit")}
                </Button>

                <Button color="primary" onClick={submit}>
                    {t("yes-continue")}
                </Button>
            </div>
        </Modal>
    );
}

export default MandatoryBreakWarning;
